import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=18836e31&scoped=true"
import script from "./ClientInformation.vue?vue&type=script&lang=js"
export * from "./ClientInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18836e31",
  null
  
)

export default component.exports